import {ReactElement} from 'react';
import {ExtractRouteParams, useParams} from 'react-router';

import {appRoute} from '../../../../../../app-route';
import {AlertFallback} from '../../../../../../component/alert-fallback/alert-fallback';
import {Page} from '../../../../../../layout/page/page';
import {Spinner} from '../../../../../../layout/spinner/spinner';
import {useReviewItem} from '../../../../../../service/reviews/reviews';
import {useReviewsCatalogList} from '../../../../../../service/reviews/reviews-catalogs';

import {EditCustomReview} from './edit-review';

export function EditReviewPageGuard(): ReactElement {
    const {reviewId} = useParams<ExtractRouteParams<typeof appRoute.reviewsManagementEditReview.path, string>>();

    if (!reviewId) {
        throw new Error('In "edit" mode "reviewId" always should be specified');
    }

    const {data, isError, isLoading} = useReviewItem(Number(reviewId));
    const {data: catalogList} = useReviewsCatalogList();

    const isExternalCatalogReview = catalogList?.find((catalog) => catalog.id === data?.catalogId)?.is_external_reviews;

    if (isLoading) {
        return <Spinner position="fixed" />;
    }

    if (isError) {
        return (
            <Page>
                <AlertFallback />
            </Page>
        );
    }

    if (!data || !(Boolean(isExternalCatalogReview) && !data.deletedAt)) {
        return (
            <Page>
                <AlertFallback />
            </Page>
        );
    }

    return <EditCustomReview review={data} />;
}
